export class PlaidStatementsConfig {
	/** The start date for statements; If no value provided, defaults to 3 months prior to the current date */
	startDate?: Date;

	/** The end date for statements; If no value provided, defaults to the current date */
	endDate?: Date;

	constructor(init?: PlaidStatementsConfig) {
		this.startDate = init?.startDate;
		this.endDate = init?.endDate;
	}
}

export interface PlaidBankStatements {
	accounts: PlaidBankStatementsAccount[];

	/** The Plaid Institution ID associated with the Item */
	institutionId: string;

	/** The name of the institution associated with the Item */
	institutionName: string;

	/** The Plaid Item ID, always unique. */
	itemId: string;
}

export interface PlaidBankStatementsAccount {
	/** Plaid's unique identifier for the account */
	accountId: string;

	/** The last 2-4 alphanumeric characters of an account's official account number. */
	accountMask: string;

	/** The name of the account, either assigned by the user or by the financial institution itself */
	accountName: string;

	/** The official name of the account as given by the financial institution */
	accountOfficialName: string;

	/** The subtype of the account */
	accountSubtype: string;

	/** The type of account */
	accountType: string;

	/** The list of statements' metadata associated with this account */
	statements: PlaidBankStatementMetadata[];
}

export interface PlaidBankStatementMetadata {
	/** A statement's metadata associated with an account */
	statementId: string;

	/** Month of the year, a number 1-12 (January through December) */
	month: number;

	/** The year of the statement */
	year: number;
}
